module.exports = __webpack_public_path__ + "assets/img/tri.67eefff8.svg";